// extracted by mini-css-extract-plugin
export default {"SettingsButton":"Home_SettingsButton__DrUPz","HomeSpace":"Home_HomeSpace__--hVj"};